"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
const react_1 = require("react");
const ToastContext_1 = require("./ToastContext");
function useToast() {
    const { setNotice } = (0, ToastContext_1.useToastContext)();
    const showToast = (0, react_1.useCallback)((props) => {
        setNotice(props);
    }, [setNotice]);
    return { showToast };
}
exports.useToast = useToast;
